import * as React from "react"
import { useNavigate } from "react-router"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"

import AppBar from "../../components/AppBar"
import Footer from "../../components/Footer"
import FullPageContentContainer from "../../components/FullPageContentContainer"
import { useAppSelector } from "../../redux"
import ContactForm from "./components/ContactForm"
import {
  Alert,
  Avatar,
  Box,
  Grid,
  Link,
  Paper,
  Stack,
  Toolbar,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"
import BugReportIcon from "@podcastsoundboard/ps-lib/ui/icons/BugReport"
import CurrencyExchangeIcon from "@podcastsoundboard/ps-lib/ui/icons/CurrencyExchange"
import SchoolIcon from "@podcastsoundboard/ps-lib/ui/icons/School"
import WarningIcon from "@podcastsoundboard/ps-lib/ui/icons/Warning"
import EmailIcon from "@podcastsoundboard/ps-lib/ui/icons/Email"

export const ContactText = () => (
  <>
    <Box className="mb-4">
      User feedback is what makes this product great, so please reach out! You
      can generally expect to hear back within a few days.
    </Box>

    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} flexGrow={1}>
        <Alert
          severity="info"
          icon={<CurrencyExchangeIcon />}
          style={{ height: "100%" }}
        >
          <b>Change of Mind</b>
          <br />
          We have a generous refund policy - reach out here if you don't end up
          using your purchase. For MacOS and iOS users, you can do this at{" "}
          <Link href="https://reportaproblem.apple.com">
            reportaproblem.apple.com
          </Link>
          .
        </Alert>
      </Grid>
      <Grid item xs={12} sm={6} flexGrow={1}>
        <Alert
          severity="success"
          icon={<SchoolIcon />}
          style={{ height: "100%" }}
        >
          <b>Enterprise & Educational Discounts</b>
          <br />
          Let us know how many accounts your organization will need and we'll be
          more than happy to arrange a tailored discount.
        </Alert>
      </Grid>
      <Grid item xs={12} sm={6} flexGrow={1}>
        <Alert
          severity="warning"
          icon={<WarningIcon />}
          style={{ height: "100%" }}
        >
          <b>Check Your Junk</b>
          <br />
          Our reply may end up in your junk mailbox, so please check there if
          you don't hear back after a few days.
        </Alert>
      </Grid>
      <Grid item xs={12} sm={6} flexGrow={1}>
        <Alert
          severity="error"
          icon={<BugReportIcon />}
          style={{ height: "100%" }}
        >
          <b>Features & Bugs</b>
          <br />
          If you're sending a bug report or a feature request, please try to
          provide as much information as possible. This should include your
          device model, operating system version, and app version.
        </Alert>
      </Grid>
    </Grid>
  </>
)

export default function Contact() {
  const [errorMessage, setErrorMessage] = React.useState("")

  const navigate = useNavigate()
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  return (
    <PageContainer darkModeEnabled={darkModeEnabled} className="min-h-screen">
      <AppBar title="Podcast Soundboard" />

      <Toolbar />

      {errorMessage && (
        <Stack className="w-full" spacing={2}>
          <Alert className="rounded-none" severity="error">
            {errorMessage}
          </Alert>
        </Stack>
      )}

      <FullPageContentContainer maxWidth="md">
        <Paper elevation={4} className="p-8 flex flex-col items-center mb-8">
          <Avatar className="m-2 bg-primary">
            <EmailIcon />
          </Avatar>

          <Typography
            component="h1"
            variant="h5"
            color="text.primary"
            className="mb-4"
          >
            Contact
          </Typography>

          <ContactText />

          <ContactForm
            setErrorMessage={setErrorMessage}
            onSend={() => navigate("/app")}
          />
        </Paper>
      </FullPageContentContainer>

      <Footer />
    </PageContainer>
  )
}
